import React from 'react';
import styles from './styles.module.scss';
import { useNavigate, useLocation } from 'react-router';
import igIcon from '../../images/logo/instagram.png';
import Image from 'react-bootstrap/Image';
import Logo from '../../images/logo/webb gra.png';

export default function Header() {

    const navigate = useNavigate();
    const location = useLocation();

    const navigateToWork = () => {
        navigate('/work');
    }
    const navigateToStore = () => {
        navigate('/fine-art');
    }
    const navigateToContact = () => {
        navigate('/contact');
    }
    const navigateToHome = () => {
        navigate('/')
    }
    const isActive = (path) => location.pathname === path;

    return(
        <div className={`col-12 d-flex align-items-center justify-content-between px-3 ${styles.header} col-md-10`}>
            {/* <div className={styles.ralewayText} onClick={navigateToHome}>
                <span className={styles.whiteText}>J</span>
                <div className={styles.redDot}></div>
            </div> */}
            {location.pathname !== '/' && ( // Gjør "J"-diven kun synlig når path ikke er "/"
                <div className={`${styles.ralewayText} col-2 col-md-1`} onClick={navigateToHome}>
                    {/* <span className={styles.whiteText}>J</span>
                    <div className={styles.redDot}></div> */}
                    <Image fluid alt="Logo" src={Logo} />
                </div>
            )}
            <div className={`col-7 d-flex align-items-center justify-content-between col-md-3 text-black ${styles.linkContainer}`}>
                <div className={`${isActive('/work') ? styles.active : styles.headerLink}`} onClick={navigateToWork}>WORK</div>
                <div className={`${isActive('/fine-art') ? styles.active : styles.headerLink}`} onClick={navigateToStore}>STORE</div>
                <div className={`${isActive('/contact') ? styles.active : styles.headerLink}`} onClick={navigateToContact}>CONTACT</div>
                <div className="col-1">
                    <a href="https://instagram.com/jurgis.bingelis/" target="_blank" rel="noopener noreferrer">
                        <Image fluid alt="Instagram-link" src={igIcon} />
                    </a>
                </div>
            </div>    
        </div>
    )
}